export class S3Bucket {
    'bucketName';
    'regionName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "regionName",
            "baseName": "regionName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3Bucket.attributeTypeMap;
    }
    constructor() {
    }
}
